"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCustomerSources = void 0;
var HttpClient_1 = require("../core/HttpClient");
/**
 * Send both dates or neither: the API refuses a lone date, and reads all time
 * without any. school_ids is for franchise owners only.
 */
var GetCustomerSources = function (filters) {
    if (filters === void 0) { filters = {}; }
    var school_ids = filters.school_ids, dates = __rest(filters, ["school_ids"]);
    var params = school_ids && school_ids.length > 0
        ? __assign(__assign({}, dates), { school_ids: school_ids.join(",") }) : dates;
    return HttpClient_1.HttpClient.get("/marketing/reports/customer-sources", { params: params });
};
exports.GetCustomerSources = GetCustomerSources;
